// extracted by mini-css-extract-plugin
export default {"inputPassword":"InputPassword_inputPassword__2UDBo"};